<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper">
            <div class="img-desktop img-desktop-advances d-lg-inline-block"></div>

            <section class="content table-content">
                <div class="container-fluid">
                    <div class="row">
                      <div class="request-title list-title mb-4">
                        <h1 class="inline-input">Entreprises</h1>
                        <router-link :to="{ name: 'enterprise-create'}"
                                     tag="button"
                                     class="export-urssaf desktop-export inline-input"
                                     v-if="isCanCreateEnterprise"
                        >Créer entreprise</router-link>
                      </div>
                    </div>

                    <div>
                        <vuetable ref="vuetable"
                                  :fields="fields"
                                  :api-mode="false"
                                  :data="enterprises"
                                  no-data-template="Aucune donnée disponible"
                                  class="table table-striped table-bordered"
                        >
                            <div slot="name" slot-scope="props">
                                <span>{{ props.rowData.name }}</span>
                            </div>
                            <div slot="dueSatus" slot-scope="props">
                                <span>{{ props.rowData.due }}</span>
                            </div>
                            <div slot="actions" slot-scope="props">
                                 <button type="button"
                                         class="btn btn__enter"
                                         @click.prevent="enter(props.rowData)"
                                 >Entrer</button>
                                <button type="button"
                                        class="btn btn__update"
                                        @click.prevent="update(props.rowData)"
                                >Modifier</button>
                            </div>
                        </vuetable>

                      <Paginator :items.sync="enterprises"
                                 :pagination.sync="pagination"
                                 class="float-right"
                                 v-if="!isEnterpriseUser"
                      ></Paginator>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import Vuetable from 'vuetable-2';
    import Paginator from '../../components/Paginator';
    import enterpriseTableFields from './enterpriseTableFields';
    import permissionManager from '../../service/manager/permissionManager';
    import { fetchEnterprises } from '@/service/api/enterprise.api';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                fields: enterpriseTableFields,
                enterprises: [],
                pagination: {
                    currentPage: 1,
                    totalItems: null,
                    itemsPerPage: 10
                },
            };
        },
        async created() {
            await this.fetchPaginatedEnterprises();
        },
        computed: {
            ...mapGetters({
                userPermissions: 'userPermissions',
                role: 'role',
            }),
            isEnterpriseUser() {
                return this.role ? permissionManager.isEnterpriseUser(this.role) : false;
            },
            isCanCreateEnterprise() {
                return permissionManager.isCanCreateEnterprise(this.userPermissions)
                    && !this.isEnterpriseUser
                ;
            },
            page() {
                return this.pagination.currentPage;
            },
        },
        methods: {
            ...mapActions({
                setEnterpriseData: 'setEnterpriseData',
                setUpdatedEnterpriseData: 'setUpdatedEnterpriseData',
            }),
            async fetchPaginatedEnterprises() {
                const { data } = await fetchEnterprises(this.pagination);
                this.enterprises = data.items;
                this.pagination.totalItems = data.totalItems;
                this.$refs.vuetable.setData(this.enterprises);
            },
            async enter(enterprise) {
                await this.setEnterpriseData(enterprise);
                await this.$router.push({ name: 'exemption-list'});
            },
            async update(enterprise) {
                await this.setUpdatedEnterpriseData(enterprise);
                await this.$router.push({ name: 'enterprise-update' });
            }
        },
        watch: {
            page() {
                this.fetchPaginatedEnterprises();
            }
        },
        components: {
            Sidebar,
            Footer,
            Vuetable,
            Paginator
        }
    }
</script>

<style lang="scss">
    .modifier-link, .modifier-link:hover {
        display: block;
        margin: 2% 0 !important;
        color: $color-primary;
        text-decoration: none;
    }
</style>